import Swiper from 'swiper';
import { Keyboard, A11y, Navigation } from "swiper/modules";

export default function initCardSlider() {

  const sliders = document.querySelectorAll('.js-card-slider');

  if (sliders.length == 0) return;

  sliders.forEach(slider => {
    const nextButton = slider.parentNode.querySelector('.swiper-button-next');
    const prevButton = slider.parentNode.querySelector('.swiper-button-prev');

    const swiper = new Swiper(slider, {
      modules: [Keyboard, A11y, Navigation],
      loop: false,
      spaceBetween: 14,
      slidesPerView: 1.16,
      a11y: {
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
        notificationClass: 'swiper-notification visually-hidden'
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },
      breakpoints: {
        480: {
          slidesPerView: 1.32,
          spaceBetween: 14,
        },
        640: {
          slidesPerView: 1.66,
          spaceBetween: 14,
        },
        768: {
          slidesPerView: 2.2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
      }
    });
  });
}